
import { useEffect, useState } from "react";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Avatar, List, ListItem, ListItemAvatar, ListItemText, Typography, Grid, Grow, IconButton, Tooltip } from "@mui/material";

import FolderIcon from "@mui/icons-material/Folder";
import LaunchIcon from "@mui/icons-material/Launch";

import { SearchTextField } from "../components/SearchTextField";

import { DialogActionsStyle, DialogContentStyle } from "../styles/DialogStyle";

import { FiltroCatalogos } from "../helpers/FiltroCatalogos";

import { CatalogosProps, DialogCatalogosProps } from '../interfaces/catalogos/CatalogosInterface';

import { catalogosList } from "../data/catalogos";

export const DialogCatalogos = ( props: DialogCatalogosProps ) => {

    const { onClose, open, ...other } = props;

    const [filtro, setFiltro] = useState( '' )

    const [catalogos, setCatalogos] = useState<CatalogosProps[]>( [] );

    const handleCancel = () => {
        onClose();
        setFiltro( '' );
    };

    const filter = ( value: string ) => {

        if( value !== ""){
            const catalogosFilter = FiltroCatalogos(catalogosList, value);
            setCatalogos( catalogosFilter );
        }
        else{
            setCatalogos(catalogosList);
        }
    }

    useEffect(() => {

        const arrayShort = catalogosList.sort((a, b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' }) );     
        setCatalogos( arrayShort );
        
    }, [ open ])    

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%' } }}
            maxWidth="sm"
            open={open}
            {...other}
        >
            <DialogTitle sx={ DialogContentStyle }>    

                <Grid container spacing={1}>

                    <Grid size={{ md: 12, xs: 12 }}>
                        Catálogos
                    </Grid>

                    <Grid size={{ md: 12, xs: 12 }} mt={1}>

                        <SearchTextField
                            label="Buscar"
                            value={ filtro }
                            onChange={ (value) => { setFiltro( value ); filter( value ); } }
                        />

                    </Grid>

                </Grid>

            </DialogTitle>

            <DialogContent sx={{ ...DialogContentStyle, height: 500 }}>              

                <List dense={false} disablePadding>   

                    { 

                        catalogos.map( ({ id, descripcion, path }, index ) => (  
                            
                            <Grow
                                key={ id } 
                                in
                                style={{ transformOrigin: '0 0 0' }}
                                {...({ timeout: 1000 })}
                            >

                                <ListItem
                                    
                                    sx={{ px: 0, py: 2 }}                                                        
                                    secondaryAction={
                                        <Tooltip title="Abrir en nueva pestaña">
                                            <IconButton href={`${ path }`} target="_blank" color="primary">
                                                <LaunchIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    divider
                                >
                                    <ListItemAvatar>

                                        <Avatar sx={{ bgcolor: 'GrayText' }}>
                                            <FolderIcon />
                                        </Avatar>

                                    </ListItemAvatar>

                                    <ListItemText primary={ <Typography variant="body1" fontWeight={'500'}>{ descripcion }</Typography> } />

                                </ListItem>         
                            
                            </Grow>

                        ))
                    }   

                </List>                 

            </DialogContent>

            <DialogActions sx={ DialogActionsStyle }>

                <Button color="secondary" onClick={handleCancel}>
                    Cerrar
                </Button>

            </DialogActions>

        </Dialog>
    );
}
